import { useState, useCallback, useEffect } from 'react';
import { userWithdrawalOption } from 'src/api/user-withdrawal-option/user-withdrawal-option';
import { UserGamificationDetailsRewardType } from 'src/contexts/UserGamificationDetailsContext/user-gamification-details-reward.type';
/**
 * Custom hook for managing user gamification details state and actions.
 * Provides functions to set user gamification details.
 */
export function useUserGamificationDetails() {
  const [userRewardState, setUserRewardState] = useState<UserGamificationDetailsRewardType | null>(null);

  const [isRewardLoaded, setIsRewardLoaded] = useState(false);

  //get user stats
  const getUserStats = useCallback(async () => {
    if (!isRewardLoaded) {
      const response = await userWithdrawalOption.getUserWithdrawalOptions();
      setUserRewardState(response);
      setIsRewardLoaded(true);
    }
  }, [isRewardLoaded]);

  useEffect(() => {
    void getUserStats();
  }, [getUserStats]);

  const setReward = (reward: UserGamificationDetailsRewardType) => {
    setUserRewardState(reward);
  };

  const refreshUserGamificationDetails = useCallback(async () => {
    try {
      const response = await userWithdrawalOption.getUserWithdrawalOptions();
      setUserRewardState(response);
    } catch (error) {
      console.error('Failed to refresh user settings:', error);
    }
  }, []);

  return {
    reward: userRewardState,
    isRewardLoaded,
    setReward,
    refreshUserGamificationDetails,
  };
}
